import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

import { IBankPaymentParsersDTO } from '../types/types';

export const getBankPaymentParsers = async () => {
    // @ts-ignore
    const url = routable.getRoute('getBankPaymentParsers');
    try {
        const res = await $api.get<IDataResponse<IBankPaymentParsersDTO[]>>(url);

        return res.data;
    } catch (error) {
        handleAxiosFetchErrorsSwal(error);
        return error.message;
    }
};
